import React, { useState } from "react";
import CardBase from "@/components/cards/CardBase";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTagsDataContext } from "@/providers/TagsDataProvider";
import { useSimplifiedUserData } from "@/providers/SimplifiedUserDataProvider";
import { TagItem } from "@/lib/stores/tagsStore";
import TagCreator from "./TagCreator";
import TagList from "./TagList";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface TagsWidgetProps {
  showTitle?: boolean;
  title?: string;
  backgroundColor?: string;
}

export default function TagsWidget({ 
  showTitle = true, 
  title = "Tags",
  backgroundColor 
}: TagsWidgetProps) {
  const { t } = usePlatformTranslation();
  const { selectedGame } = useSimplifiedUserData();
  const { tags, isLoading, refreshTags } = useTagsDataContext();

  // Tags state
  const [isAddingTag, setIsAddingTag] = useState(false);

  // Group tags by their group
  const groupedTags = tags.reduce((acc, tag) => {
    const group = tag.group_name || "Ungrouped";
    if (!acc[group]) acc[group] = [];
    acc[group].push(tag);
    return acc;
  }, {} as Record<string, TagItem[]>);

    

  if (!selectedGame) {
    return (
      <CardBase backgroundColor={backgroundColor}>
        <div className="flex items-center justify-center h-32">
          <p className="text-gray-500">{t('platform.cards.widgets.please_select_a_game_to_manage_tags')}</p>

        </div>
      </CardBase>
    );
  }

  return (
    <CardBase backgroundColor={backgroundColor}
      className="h-full flex flex-col"
      style={{
        maxHeight: "calc(100vh - 200px)",
        minHeight: "calc(100vh - 200px)",
      }}
    >
      {/* Sticky Header */}
      {showTitle && (
        <div className="sticky top-0 z-10 bg-background border-b border-input px-4 py-4 flex-shrink-0">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
              {title}
            </h3>
            <Button
              onClick={() => setIsAddingTag(true)}
              disabled={isAddingTag}
              size="sm"
              variant="default"
              
              className="flex justify-center items-center gap-2" 
            >
              Create Tag Group
            </Button>
          </div>
        </div>
      )}

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="space-y-4 p-4">
          {/* Tag Creator Component */}
          <TagCreator
            isOpen={isAddingTag}
            onClose={() => setIsAddingTag(false)}
            onSuccess={() => {
              // Refresh tags data to show newly created tags
              refreshTags();
            }}
          />

          {/* Tag List Component */}
          <TagList
            groupedTags={groupedTags}
            isLoading={isLoading}
            onRefresh={refreshTags}
                    />
        </div>
        </div>
    </CardBase>
  );
} 